import { Modal } from '@/atoms';

import type { FunctionComponent } from 'react';
import type { TypeModalFormProps } from './types';

export const ModalForm: FunctionComponent<TypeModalFormProps> = ({
  className = '',
  isOpen,
  closeModal,
  children,
  title = 'Motivo del contacto',
}: TypeModalFormProps) => (
  <Modal
    isOpen={isOpen}
    closeModal={closeModal}
    className={`md:w-[590px] ${className}`}
    title={title}
    unmount={true}
  >
    {children}
  </Modal>
);

ModalForm.displayName = 'ModalContact';
